import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44ad47a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unitTime" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 审批人")
const _hoisted_5 = {
  key: 0,
  class: "image name"
}
const _hoisted_6 = { class: "img" }
const _hoisted_7 = { class: "font" }
const _hoisted_8 = {
  key: 0,
  class: "iconfont"
}
const _hoisted_9 = {
  key: 1,
  class: "nodata"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无审批人", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dotted" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "抄送人", -1))
const _hoisted_14 = {
  key: 2,
  class: "image name"
}
const _hoisted_15 = { class: "img" }
const _hoisted_16 = { class: "font" }
const _hoisted_17 = {
  key: 0,
  class: "iconfont"
}
const _hoisted_18 = {
  key: 3,
  class: "nodata"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无抄送人", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, "（" + _toDisplayString(_ctx.review_carbon.review.length) + "人依次审批）", 1)
      ]),
      (_ctx.review_carbon.review.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review_carbon.review, (e, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "iconF",
                key: i
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_van_image, {
                    src: e.avatar,
                    round: ""
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(e.name), 1)
                ]),
                (i + 1 !== _ctx.review_carbon.review.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, ""))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11)),
      _hoisted_12,
      _hoisted_13,
      (_ctx.review_carbon.carbon.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.review_carbon.carbon, (e, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "iconF",
                key: i
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_van_image, {
                    src: e.avatar,
                    round: ""
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(e.name), 1)
                ]),
                (i + 1 !== _ctx.review_carbon.carbon.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, ""))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
    ])
  ]))
}